/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { BloodShop, BloodShopInterface } from "../BloodShop";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "activator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "boonId",
        type: "uint16",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "BoonActivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint16",
        name: "boonId",
        type: "uint16",
      },
    ],
    name: "BoonAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint16",
        name: "boonId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newLength",
        type: "uint256",
      },
    ],
    name: "BoonLengthChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint16",
        name: "boonId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newPrice",
        type: "uint256",
      },
    ],
    name: "BoonPriceChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint16",
        name: "boonId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "BoonUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarderAddress_",
        type: "address",
      },
    ],
    name: "__TrustedForwarderRecipientUpgradeable_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
    ],
    name: "activateBoon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "activateBoonForGawd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "activatedBoons",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "addBoon",
    outputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
    ],
    name: "boonActivationBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "boonActivationBlockForGawd",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
    ],
    name: "boonExpiryBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "boonExpiryBlockForGawd",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "boonLengths",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "boonPrices",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "tokenIds",
        type: "uint16[]",
      },
    ],
    name: "boonStats",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "tokenIds",
        type: "uint16[]",
      },
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "boonStatsForGawd",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "boons",
    outputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "boonsCount",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnBlood",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "buyBoon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBloodAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getBoon",
    outputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "id",
            type: "uint16",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "length",
            type: "uint256",
          },
        ],
        internalType: "struct BloodShop.Boon",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    name: "getBoonByName",
    outputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "id",
            type: "uint16",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "length",
            type: "uint256",
          },
        ],
        internalType: "struct BloodShop.Boon",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    name: "getBoonId",
    outputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getBoonLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
    ],
    name: "getBoonPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarderAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "bloodAddress",
        type: "address",
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
    ],
    name: "isActiveBoon",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "isActiveBoonForGawd",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "secondsPerBlock",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "bloodAddress",
        type: "address",
      },
    ],
    name: "setBloodAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "setBoon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "blocks",
        type: "uint256",
      },
    ],
    name: "setBoonLength",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    name: "setBoonName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "setBoonPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "id",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "setBoonPriceAndLength",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trustedForwarder_",
        type: "address",
      },
    ],
    name: "setForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "blocks",
        type: "uint16",
      },
    ],
    name: "setSecondsPerBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawBlood",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type BloodShopConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BloodShopConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BloodShop__factory extends ContractFactory {
  constructor(...args: BloodShopConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "BloodShop";
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BloodShop> {
    return super.deploy(overrides || {}) as Promise<BloodShop>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): BloodShop {
    return super.attach(address) as BloodShop;
  }
  override connect(signer: Signer): BloodShop__factory {
    return super.connect(signer) as BloodShop__factory;
  }
  static readonly contractName: "BloodShop";

  public readonly contractName: "BloodShop";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BloodShopInterface {
    return new utils.Interface(_abi) as BloodShopInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BloodShop {
    return new Contract(address, _abi, signerOrProvider) as BloodShop;
  }
}
